import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { withQueryParams } from "../helpers/common.js";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "date-fns";
import "date-fns/locale";
import "fast-memoize";
import "../appointment-schedule.types.js";
import "react/jsx-runtime";
import "axios";
const getAppointments = (axios) => async (params, signal) => {
  const { data = [] } = await axios.get("/api/v1/internal/appointments", {
    signal,
    params
  });
  return data;
};
const REFETCH_TIME = 30;
const useAppointments = ({ clinicReferenceId, auth, params: defaultParams }) => {
  var _a;
  const { echoCore } = useAxiosProvider();
  const params = useMemo(
    () => {
      var _a2;
      return {
        ...defaultParams,
        employeeReferenceIds: (_a2 = defaultParams == null ? void 0 : defaultParams.employeeReferenceIds) == null ? void 0 : _a2.join(","),
        clinicReferenceId
      };
    },
    [defaultParams, clinicReferenceId, auth]
  );
  const queryKey = useMemo(() => ["appointments", params], [params]);
  const enabled = !!clinicReferenceId && !!echoCore && !!auth && !!(defaultParams == null ? void 0 : defaultParams.startAfter) && !!((_a = defaultParams == null ? void 0 : defaultParams.employeeReferenceIds) == null ? void 0 : _a.length);
  const { data = [], ...queryResult } = useQuery({
    // @ts-expect-error TODO:
    queryKey,
    queryFn: withQueryParams(getAppointments(echoCore)),
    keepPreviousData: true,
    refetchInterval: REFETCH_TIME * (60 * 1e3),
    enabled
  });
  return {
    queryKey,
    queryResult,
    data
  };
};
export {
  useAppointments
};
